// src/app/(dashboard)/dashboard/page.tsx

import DashboardLayout from "../../components/dashboard/DashboardLayout ";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

/* import CalendarEvents from "@/components/calendar/CalendarEvents";
 */
export default function Dashboard() {
  return (
    <>
      <DashboardLayout />
      <FabEyeButton />
    </>
  );
}
